import { PropsWithChildren } from 'react'
import CopyButton from '../../Buttons/CopyButton'

const TextWithCopy = (props: PropsWithChildren<{ text: string }>) => {
  return (
    <div className="inline-flex-gap gap8 center">
      {props.children}
      <CopyButton text={props.text} />
    </div>
  )
}

export default TextWithCopy
